export default "__VITE_ASSET__CDKfZCMl__"